"use client";

import * as React from "react";

export function HeroStickman({ className }: { className?: string }) {
	const videoRef = React.useRef<HTMLVideoElement>(null);

	React.useEffect(() => {
		const v = videoRef.current;
		if (!v) return;
		v.muted = true;
		const p = v.play();
		if (p && typeof p.catch === "function") {
			p.catch(() => {});
		}
	}, []);

	return (
		<div
			className={`bg-background relative mx-auto flex aspect-[3/4] w-full items-center justify-center overflow-hidden ${className ?? ""}`}
		>
			<video
				ref={videoRef}
				src="/illustrations/stickman_anim.mp4"
				poster="/illustrations/stickman_anim_poster.webp"
				autoPlay
				muted
				loop
				playsInline
				preload="auto"
				aria-hidden="true"
				tabIndex={-1}
				className="h-full w-full origin-center scale-125 object-cover mix-blend-darken"
			/>
		</div>
	);
}
